import React, { useCallback, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "reactstrap";

import IconButton from "shared/react_components/IconButton";

import { none } from "stylesheets/utilities/pointerEvents.module.scss";

const fallbackCopyToClipboard = (url) => {
  const textArea = document.createElement("textarea");
  textArea.value = url;

  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  document.execCommand("copy");
  document.body.removeChild(textArea);
};

const ShareButton = ({ shareURL, tooltipPlacement }) => {
  const shareButtonRef = useRef(null);
  const [defaultToolTipOpen, setDefaultToolTipOpen] = useState(false);
  const [copiedToolTipOpen, setCopiedToolTipOpen] = useState(false);

  const onShare = useCallback(() => {
    const url = typeof shareURL === "function" ? shareURL() : shareURL;
    navigator.clipboard
      ? navigator.clipboard.writeText(url)
      : fallbackCopyToClipboard(url);
    setDefaultToolTipOpen(false);
  }, [shareURL]);

  const onMouseLeave = () => {
    setCopiedToolTipOpen(false);
  };

  return (
    <React.Fragment>
      <div ref={shareButtonRef} onMouseLeave={onMouseLeave}>
        <IconButton icon="share" onClick={onShare} />
      </div>
      <Tooltip
        target={shareButtonRef}
        placement={tooltipPlacement}
        isOpen={defaultToolTipOpen}
        toggle={() => !copiedToolTipOpen && setDefaultToolTipOpen(!defaultToolTipOpen)}
        className={none}
      >
        Share URL
      </Tooltip>
      <Tooltip
        target={shareButtonRef}
        placement={tooltipPlacement}
        isOpen={copiedToolTipOpen}
        trigger="click"
        toggle={() => setCopiedToolTipOpen(!copiedToolTipOpen)}
        className={none}
      >
        Copied to clipboard
      </Tooltip>
    </React.Fragment>
  );
};

ShareButton.propTypes = {
  shareURL: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  tooltipPlacement: PropTypes.string
};

ShareButton.defaultProps = {
  shareURL: () => window.location.href,
  tooltipPlacement: "left"
};

export default ShareButton;
